/** Optional decorative artwork; a missing or invalid SVG leaves its tile empty. */
export function createAgentLogo(svg, ownerDocument) {
  if (typeof svg !== 'string' || !svg.trim()) return null;
  const template = ownerDocument.createElement('template');
  template.innerHTML = svg;
  const icon = template.content.firstElementChild;
  if (icon?.localName !== 'svg' || icon.namespaceURI !== 'http://www.w3.org/2000/svg') return null;
  icon.setAttribute('aria-hidden', 'true');
  icon.setAttribute('focusable', 'false');
  return icon;
}
